import React from 'react';

const FilteredContext = React.createContext();
export default FilteredContext;
